/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhookEndpointsDelete } from "../../funcs/webhookEndpointsDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteWebhookEndpointRequest$inboundSchema,
};

export const tool$webhookEndpointsDelete: ToolDefinition<typeof args> = {
  name: "webhook-endpoints-delete",
  description: `Delete Webhook Endpoint

Delete a webhook endpoint to stop delivering webhook notifications to its URL.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhookEndpointsDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
